var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTooltipIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.9999 3.5999C6.2999 3.5999 6.5999 3.3749 6.5999 2.9999C6.5999 2.6999 6.3749 2.3999 5.9999 2.3999C5.6999 2.3999 5.3999 2.6999 5.3999 2.9999C5.3999 3.2999 5.6999 3.5999 5.9999 3.5999Z",
    fill: "#414141"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.1248 8.6998H6.4498V4.8748C6.4498 4.6498 6.2248 4.4248 5.9998 4.4248H5.0998C4.8748 4.4248 4.6498 4.6498 4.6498 4.8748C4.6498 5.0998 4.8748 5.3248 5.0998 5.3248H5.5498V8.6248H4.8748C4.6498 8.6248 4.4248 8.8498 4.4248 9.0748C4.4248 9.2998 4.6498 9.5248 4.8748 9.5248H7.1248C7.3498 9.5248 7.5748 9.2998 7.5748 9.0748C7.5748 8.8498 7.3498 8.6998 7.1248 8.6998Z",
    fill: "#414141"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 0C2.7 0 0 2.7 0 6C0 9.3 2.7 12 6 12C9.3 12 12 9.3 12 6C12 2.7 9.3 0 6 0ZM6 11.1C4.575 11.1 3.3 10.5 2.4 9.6C1.5 8.7 0.9 7.425 0.9 6C0.9 3.225 3.15 0.9 6 0.9C8.85 0.9 11.1 3.15 11.1 6C11.1 7.425 10.5 8.7 9.6 9.6C8.7 10.5 7.425 11.1 6 11.1Z",
    fill: "#414141"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltipIcon);
export default __webpack_public_path__ + "static/media/tooltip-icon.bd10b0dd79013e4de83017d83082aed3.svg";
export { ForwardRef as ReactComponent };